import React from "react";
import IntFileLogDetail from "../component/IntFileLogDetail";

const IntFileLogDetailContainer = () => (<IntFileLogDetail />)

export default IntFileLogDetailContainer;
